'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface HeroCTAProps {
  primaryText: string;
  secondaryText: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
}

export default function HeroCTA({
  primaryText,
  secondaryText,
  onPrimaryClick,
  onSecondaryClick,
}: HeroCTAProps) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4">
      <a
        href="https://3qoXrM.short.gy/8E4z28"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 sm:gap-3 bg-accent text-accent-foreground pl-5 sm:pl-6 md:pl-8 pr-1.5 sm:pr-2 py-2.5 sm:py-3 rounded-full font-semibold text-sm sm:text-base hover:bg-accent-hover transition-all duration-300 shadow-lg group"
      >
        {primaryText}
        <span className="bg-white text-accent p-1.5 sm:p-2 rounded-full transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5">
          <Icon name="ArrowUpRightIcon" size={18} className="sm:w-5 sm:h-5" />
        </span>
      </a>
      <a
        href="https://3qoXrM.short.gy/8E4z28"
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-2 sm:gap-3 glass-panel text-white pl-5 sm:pl-6 md:pl-8 pr-1.5 sm:pr-2 py-2.5 sm:py-3 rounded-full font-medium text-sm sm:text-base hover:bg-white/20 transition-all duration-300 group"
      >
        {secondaryText}
        <span className="bg-primary text-white p-1.5 sm:p-2 rounded-full border border-white/10">
          <Icon name="PlayIcon" size={18} className="sm:w-5 sm:h-5" />
        </span>
      </a>
    </div>
  );
}